import { CircularProgress } from "@material-ui/core";
import { isCDR, isHotStar, isMuthoot, isOrix, isStar, isVikalp } from "Routes/Routes";
import {
  ARBITRATION,
  ARBITRATOR,
  CASE_MANAGER,
  CLAIMANT_COMPLETE,
  CLAIMANT_SUBMITTED,
  COMPLETE,
  FINAL_RESPONDENT_COMPLETE,
  FINAL_RESPONDENT_INPROGRESS,
  IO_COMPLETE,
  IO_INPROGRESS,
  MD_COMPLETE,
  MD_INPROGRESS,
  MEDIATOR,
  MUTHOOT_SECRETARIAT,
  NODAL_COMPLETE,
  NODAL_INPROGRESS,
  RESPONDENT_COMPLETE,
  RESPONDENT_INPROGRESS,
  REVIEW_COMPLETE,
  RO_AFTER_REVIEW,
  VENDOR,
  ZONAL_COMPLETE,
  ZONAL_INPROGRESS,
} from "app/constants";
import DisputeDisplay from "features/singleDispute/DisputeDisplay";
import RespondentFlowSelection from "features/singleDispute/RespondentFlowSteps/RespndentFlowSelection";
import RespondentSelectionStatus from "features/singleDispute/RespondentFlowSteps/RespondentSelectionStatus";
import React from "react";
import { useDispatch } from "react-redux";
import { MuthootCaseResolved, orixCaseResolved, updateDispute } from "slices/disputeSlice";
import DisputeDisplayHotstar from "../DisputeDisplay/DisputeDisplayHotstar";
import DisputeDisplayHotstarNew from "../DisputeDisplay/DisputeDisplayHotstarNew";
import SingleDisputeDetails from "../SingleDisputeDetails";
import DisputeDisplayStar from "../DisputeDisplay/DisputeDisplayStar";
import DisputeDetailsMuthoot from "features/disputes/MuthootDisputes/DisputeDetailsMuthoot";
import { useResumeFilling } from "contexts/ResumeFilling";
import DisputeDetailsOrix from "Clients/OrixIndia/DisputeDetailsOrix";

export default function RespondentFlowSteps({
  activeDispute,
  activeCase,
  profile,
  flows,
}) {
  console.log("activeDispute3:", activeDispute);
  console.log("activeCase3:", activeCase);
  let dispatch = useDispatch();
  const { resumeFilling } = useResumeFilling();
  function getStepContent() {
    switch (activeDispute.status) {
      case "new":
        if(isMuthoot){
          return (
            <DisputeDetailsMuthoot
              activeDispute={activeDispute}
              activeCase={activeCase}
              profile={profile}
            />
          )
        }else if(isOrix) {
          return (
            <DisputeDetailsOrix
              activeDispute={activeDispute}
              activeCase={activeCase}
              profile={profile}
            />
          );
        } else {
          return (
            <RespondentFlowSelection
              activeDispute={activeDispute}
              activeCase={activeCase}
              flows={flows}
              profile={profile}
            />
          );
        }
      case RESPONDENT_INPROGRESS:
      case IO_INPROGRESS:
      case MD_INPROGRESS:
      case FINAL_RESPONDENT_INPROGRESS:
      case ZONAL_INPROGRESS:
      case NODAL_INPROGRESS:
        if (activeCase.case_status !== REVIEW_COMPLETE) {
          if(isMuthoot && !resumeFilling){
            return (
              <DisputeDetailsMuthoot
                activeDispute={activeDispute}
                activeCase={activeCase}
                profile={profile}
              /> 
            )
          }
          if(isOrix && !resumeFilling){
            return (
              <DisputeDetailsOrix
                activeDispute={activeDispute}
                activeCase={activeCase}
                profile={profile}
              /> 
            )
          }
          return <SingleDisputeDetails profile={profile} />;
        } else {
          //Update dispute to claimant complete in case of arbitration
          if (activeDispute.flow_type === ARBITRATION) {
            if(
              (activeDispute?.status === MD_INPROGRESS && profile?.profile_type === MEDIATOR) || 
              (activeDispute?.status === IO_INPROGRESS && profile?.profile_type === ARBITRATOR) || 
              (activeDispute?.status === NODAL_INPROGRESS && profile?.profile_type === CASE_MANAGER) ||
              (activeDispute?.status === ZONAL_INPROGRESS && profile?.profile_type === VENDOR) ||
              (activeDispute?.status === RESPONDENT_INPROGRESS && profile?.profile_type === MUTHOOT_SECRETARIAT)
            ){
              dispatch(
                updateDispute({
                  id: activeDispute.id,
                  status: activeDispute?.status === IO_INPROGRESS ? IO_COMPLETE : activeDispute?.status === MD_INPROGRESS ? MD_COMPLETE : activeDispute?.status === NODAL_INPROGRESS ? NODAL_COMPLETE : activeDispute?.status === ZONAL_INPROGRESS ? ZONAL_COMPLETE : CLAIMANT_COMPLETE,
                })
              )
              .catch((err) => {
                console.log(err);
              });
            } else {
              if(isMuthoot){
                return (
                  <DisputeDetailsMuthoot
                    activeDispute={activeDispute}
                    activeCase={activeCase}
                    profile={profile}
                  /> 
                )
              } else if(isOrix) {
                  return (
                    <DisputeDetailsOrix
                      activeDispute={activeDispute}
                      activeCase={activeCase}
                      profile={profile}
                    /> 
                  )
                }
            }
          } else {
            // its adjudication. Not tasks for respondent .Wait for claimant to respond
            dispatch(
              updateDispute({
                id: activeDispute.id,
                status: RESPONDENT_COMPLETE,
              })
            );
          }
          return <CircularProgress />;
        }

      case RESPONDENT_COMPLETE:
        //if (activeDispute.flow_type === MEDIATION) {
        return (
          <RespondentSelectionStatus flowType={activeCase.proposed_flow} />
        );
      //} else {

      ///}
      //}

      // if (activeCase.proposed_flow === ARBITRATION) {
      //   if (activeCase.case_status !== REVIEW_COMPLETE) {
      //     return <SingleDisputeDetails />;
      //   }
      // }
      // return (
      //   <RespondentDecisionStatus
      //     flowType={activeCase.proposed_flow}
      //     name={CLAIMANT}
      //     id={activeDispute.id}
      //   />
      // );
      case COMPLETE:
        return "Case is complete";


      case CLAIMANT_COMPLETE:
      case IO_COMPLETE:
      case MD_COMPLETE:
      case FINAL_RESPONDENT_COMPLETE:
      case CLAIMANT_SUBMITTED:
      case ZONAL_COMPLETE:
      case NODAL_COMPLETE:
      default:
        if (isHotStar ) {
          return (
            <DisputeDisplayHotstarNew
              activeDispute={activeDispute}
              activeCase={activeCase}
              profile={profile}
            />
          );
        }else if(isStar){
          return(
            <DisputeDisplayStar
              activeDispute={activeDispute}
              activeCase={activeCase}
              profile={profile}
            />
          )
        } else if (isMuthoot) {
          return (
            <DisputeDetailsMuthoot
              activeDispute={activeDispute}
              activeCase={activeCase}
              profile={profile}
            /> 
          )
        } else if (isOrix) {
          return (
            <DisputeDetailsOrix
              activeDispute={activeDispute}
              activeCase={activeCase}
              profile={profile}
            /> 
          )
        } else if (isHotStar || isStar || isMuthoot || isCDR || isVikalp) {
          return (
            <DisputeDisplayHotstar
              activeDispute={activeDispute}
              activeCase={activeCase}
              profile={profile}
            />
          );
        } else {
          return (
            <DisputeDisplay
              activeDispute={activeDispute}
              activeCase={activeCase}
            />
          );
        }
    }
  }

  return (
    <React.Fragment>
      {getStepContent(activeDispute, activeCase, profile)}
    </React.Fragment>
  );
}
